import Service from "../Service";

const resource = "TasParamTypeMaterial/";

export default {
  pagination(parameters, requestID) {
    return Service.post(resource + "pagination", parameters, {
      params: { requestID },
    });
  },
  save(parameters, requestID) {
    return Service.post(resource + "save", parameters, {
      params: { requestID },
    });
  },
  list(parameters, requestID) {
    return Service.post(resource + "list", parameters, {
      params: { requestID, ...parameters },
    });
  },
};
